// src/redux/reducers/siteReducer.js
import { SET_SITE_LIST } from '../actions/siteActions';

const initialState = {
  siteList: [],
};

const siteReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SITE_LIST:
      return {
        ...state,
        siteList: action.payload,
      };
    default:
      return state;
  }
};

export default siteReducer;
